import React from 'react';
import styled from 'styled-components';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { Box } from '../layout/Grid';
import { withStyles } from '@material-ui/core';

const StyledSelectWrapper = styled(Box)`
  position: relative;

  .MuiInput-underline:after {
    border-color: transparent;
  }
  .MuiInput-underline:hover:not(.MuiInput-disabled):not(.MuiInput-focused):not(.MuiInput-error):before {
    border: 0;
  }
  .MuiInput-underline:before {
    border: 0;
  }
  .MuiSelect-select:focus {
    background-color: transparent;
  }

  .MuiSelect-nativeInput {
    position: absolute;
    opacity: 0;
  }
`;

const styles = {
  paper: {
    marginTop: '3px',
    textTransform: 'capitalize',
  },
};

const GetStartedSectionStyledSelect = styled(Select).attrs({
  classes: { root: 'root', selectMenu: 'selectMenu', select: 'select' },
})`
  width: 100%;
  height: 100%;

  .root {
    width: 100%;
    height: 100%;
    border: 0;
    border-radius: 5px;
    background-color: white;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  }
  .select {
    padding: 14px;
    font-size: 16px;
    font-weight: 600;
  }
`;

const StyledSelect = styled(Select).attrs({
  classes: { root: 'root', selectMenu: 'selectMenu', select: 'select' },
})`
  width: 100%;
  height: 100%;
  .root {
    width: 100%;
    height: 100%;
    border: solid 1px #eaeaea;
    border-radius: 5px;
  }
  .select {
    padding: 12px 24px;
    font-size: 13px;
    min-width: 100px;
  }
`;

const SelectItem = props => {
  const { native, ...rest } = props;
  return native ? <option {...rest} /> : <MenuItem {...rest} />;
};

type Props = {
  className?: string;
  id?: string;
  valueKey?: string;
  displayTextKey?: string;
  getStartedStyling?: boolean;
  name?: string;
  onChange?(
    e: React.ChangeEvent<{
      name?: string;
      value: unknown;
    }>
  ): void;
  selectedValue?: string;
  classes?: any;
  options: { [key: string]: any }[];
  disabled?: boolean;
  native?: boolean;
  defaultValue?: string;
  value?: string;
};

const SelectDropDown = withStyles({
  paper: {
    marginTop: '3px',
    textTransform: 'capitalize',
  },
})((props: Props) => {
  const valueKey = props.valueKey ? props.valueKey : 'value';
  const displayTextKey = props.displayTextKey ? props.displayTextKey : 'name';
  return (
    <StyledSelectWrapper className={props.className}>
      {props.getStartedStyling ? (
        <GetStartedSectionStyledSelect
          id={props.id}
          name={props.name}
          value={props.selectedValue}
          onChange={props.onChange}
          MenuProps={{
            getContentAnchorEl: null,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
            classes: {
              paper: props.classes.paper,
            },
          }}
          defaultValue={props.defaultValue}
          data-testid={props['data-testid']}
        >
          {props.options.map((item, index) => (
            <MenuItem key={index} value={item[valueKey]}>
              {item[displayTextKey]}
            </MenuItem>
          ))}
        </GetStartedSectionStyledSelect>
      ) : (
        <StyledSelect
          id={props.id}
          name={props.name}
          native={props.native}
          value={props.selectedValue}
          onChange={props.onChange}
          disabled={props.disabled}
          MenuProps={{
            getContentAnchorEl: null,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
            classes: {
              paper: props.classes.paper,
            },
          }}
          defaultValue={props.defaultValue}
          data-testid={props['data-testid']}
        >
          {props.options.map((item, index) => (
            <SelectItem
              key={index}
              value={item[valueKey]}
              native={props.native}
            >
              {item[displayTextKey]}
            </SelectItem>
          ))}
        </StyledSelect>
      )}
    </StyledSelectWrapper>
  );
});

export default SelectDropDown;
